var mortgageCalculator = {

    amt: 0,
    dep: 0,
    apr: 0,
    rpd: 0,
    pmt: document.getElementById('pmt'),

    init: function() {
        mortgageCalculator.setup();
        mortgageCalculator.eventHandler();
    },
 
    setup: function() {
        var mPmt = mortgageCalculator.calculatePayment();
        pmt.textContent = mPmt.toFixed();
    },

    eventHandler: function() {

        let mortgageAmount  = document.getElementById('mortgage-amount'),
            yourDeposit     = document.getElementById('the-deposit'),
            annualInterest  = document.getElementById('annual-interest'),
            repaymentPeriod = document.getElementById('repayment-period');

        mortgageAmount.addEventListener('input', function(event) {
            mortgageCalculator.amt = mortgageAmount.value;
            var payment = mortgageCalculator.calculatePayment();
            mortgageCalculator.setRepayment(payment);
        }, true);

        yourDeposit.addEventListener('input', function(event) {
            mortgageCalculator.dep = yourDeposit.value;
            var payment = mortgageCalculator.calculatePayment();
            mortgageCalculator.setRepayment(payment);
        }, true);

        annualInterest.addEventListener('input', function(event) {
            mortgageCalculator.apr = annualInterest.value;
            var payment = mortgageCalculator.calculatePayment();
            mortgageCalculator.setRepayment(payment);
        }, true);

        repaymentPeriod.addEventListener('input', function(event) {
            mortgageCalculator.rpd = repaymentPeriod.value;
            var payment = mortgageCalculator.calculatePayment();
            mortgageCalculator.setRepayment(payment);
        }, true);
    },

    getValues: function() {
        amt = document.getElementById('mortgage-amount').value;
        dep = document.getElementById('the-deposit').value;
        apr = document.getElementById('annual-interest').value;
        rpd = document.getElementById('repayment-period').value;
        apr /= 1200;
        rpd *= 12;
    },

    calculatePayment: function() {
        mortgageCalculator.getValues();
        var payment = (amt - dep) * (apr * Math.pow((1 + apr), rpd)) / (Math.pow((1 + apr), rpd) - 1);
        return Math.ceil(payment);
    },

    setRepayment: function(value) {
        pmt.textContent = value.toFixed();
    }
};

let mortgage = document.getElementById('mortgage-calculator');
if (typeof(mortgage) != 'undefined' && mortgage != null){
    window.addEventListener('load', mortgageCalculator.init, true);
}
